import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { SocioResponse } from '../../../models/socioResponse.model';
import { SociosService } from '../../../services/socios.service';
import { SpinnerService } from '../../../services/spinner.service';
import { JwtHelper } from '../../../helpers/jwtDecode.helper';
import { retornaDescricao } from '../../../shared/mock/descricao';
import { LoginHelper } from '../../../helpers/login.helper';
import { ProLaboreSocioEdicaoResponse } from '../../../models/proLaboreSocio.model';

@Component({
  selector: 'app-socios-listagem',
  templateUrl: './socios-listagem.component.html',
  styleUrls: ['./socios-listagem.component.scss']
})
export class SociosListagemComponent implements OnInit {

  @Output() tituloChange = new EventEmitter<string>();
  @Output() iconeChange = new EventEmitter<string>();

  @Output() tituloDescricao = new EventEmitter<string>();
  @Output() textoDescricao = new EventEmitter<string>();
  @Output() mostrarDescricao = new EventEmitter<boolean>();

  @ViewChild('dt') dt: Table | undefined;

  socios: SocioResponse[] = [];
  usuarioId: string = '';
  exibirDetalhes: boolean = false;
  exibirEditarProLabore: boolean = false;
  socioSelecionado?: SocioResponse;
  isLoading = false;

  constructor(
    private location: Location,
    private router: Router,
    private sociosService: SociosService,
    private spinnerService: SpinnerService,
    private jwtHelper: JwtHelper
  ) { }

  ngOnInit(): void {
    this.tituloChange.emit('Sócios');
    this.iconeChange.emit("pi pi-list");
    this.tituloDescricao.emit(retornaDescricao('gestaoSocios').titulo);
    this.textoDescricao.emit(retornaDescricao('gestaoSocios').texto);
    this.mostrarDescricao.emit(true)

    this.usuarioId = this.jwtHelper.getUserIdFromToken();
    const loginHelper = new LoginHelper(this.router);
    const loginData = loginHelper.get();
    
    this.carregarSocios();
  }

  ngOnDestroy(): void {
    this.mostrarDescricao.emit(false);
  }

  carregarSocios() {
    if (!this.usuarioId) return;

    this.isLoading = true;
    this.spinnerService.show('Carregando sócios...');
    this.sociosService.listarSocios(this.usuarioId).subscribe({
      next: (socios) => {
        this.socios = socios;
        this.isLoading = false;
        this.spinnerService.hide();
      },
      error: (err) => {
        this.isLoading = false;
        this.spinnerService.hide();
        console.error('Erro ao carregar sócios:', err);
      }
    });
  }

  verDetalhes(socio: SocioResponse) {
    this.socioSelecionado = socio;
    this.exibirDetalhes = true;
  }

  editarProLabore(socio: SocioResponse) {
    this.socioSelecionado = socio;
    this.exibirEditarProLabore = true;
  }

  onProLaboreSaved(response: ProLaboreSocioEdicaoResponse) {
    if (this.socioSelecionado && this.socioSelecionado.id === response.socioId) {
      this.socioSelecionado = {
        ...this.socioSelecionado,
        vrSalFx: response.proLaboreMensal ?? undefined,
        inssAproximado: response.inssSobreProLabore ?? undefined,
        baseInss: response.irrfSobreProLabore ?? undefined,
        contribuicaoInss: response.valorLiquidoProLabore ?? undefined,
        participacaoSocietaria: response.participacaoSocietaria ?? undefined,
        duploVinculo: response.duploVinculo ?? undefined,
        diaPagamentoProLabore: response.diaPagamentoProLabore ?? undefined,
        dataInicioValidade: `${String(response.dataInicioValidadeMes).padStart(2, '0')}/${response.dataInicioValidadeAno}`
      };
    }

    this.exibirEditarProLabore = false;
    this.carregarSocios();
  }

  applyFilterGlobal(value: string): void {
    if (this.dt) {
      this.dt.filterGlobal(value, 'contains');
    }
  }

  openNew() {
    this.router.navigate(['/socios/adicionar']);
  }

  voltar(): void {
    this.location.back();
  }
}
